import { render, staticRenderFns } from "./zjb.vue?vue&type=template&id=3f32e120&scoped=true"
import script from "./zjb.vue?vue&type=script&lang=js"
export * from "./zjb.vue?vue&type=script&lang=js"
import style0 from "./zjb.vue?vue&type=style&index=0&id=3f32e120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f32e120",
  null
  
)

export default component.exports